(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Sort select → reload with sort param
  document.querySelector('[data-sort-select]')?.addEventListener('change', function() {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    window.location.href = url.toString();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Announcement bar height + scroll detection.
  // Re-queries DOM each call so it survives Theme Editor section re-renders
  // (Shopify replaces the section DOM on edit, which orphans cached refs).
  function getEls() {
    return {
      header: document.querySelector('[data-header]'),
      announcement: document.querySelector('.announcement-bar'),
      hasHero: !!document.querySelector('.hero, .about-hero'),
    };
  }

  const updateAnnouncementHeight = () => {
    const { announcement } = getEls();
    if (announcement) {
      const h = announcement.offsetHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
  };

  function applyInitialState() {
    const { header, hasHero } = getEls();
    if (!header) return;
    // Pages without a hero always show the scrolled (dark) header
    if (!hasHero) {
      header.classList.add('is-scrolled');
    }
  }

  const onScroll = () => {
    const { header, announcement, hasHero } = getEls();
    if (!header) return;
    const announcementH = announcement ? announcement.offsetHeight : 0;
    const scrolled = window.scrollY > announcementH;

    if (hasHero) {
      // On hero pages: transparent at top, dark when scrolled
      header.classList.toggle('is-scrolled', scrolled);
    } else {
      // Non-hero pages: always is-scrolled (covers section re-renders)
      header.classList.add('is-scrolled');
    }

    // Slide header to top when announcement scrolls out of view
    if (scrolled) {
      document.documentElement.style.setProperty('--announcement-height', '0px');
    } else {
      updateAnnouncementHeight();
    }
  };

  updateAnnouncementHeight();
  window.addEventListener('resize', updateAnnouncementHeight);
  applyInitialState();
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Re-apply state when Shopify editor re-renders any section
  document.addEventListener('shopify:section:load', () => {
    updateAnnouncementHeight();
    applyInitialState();
    onScroll();
  });

  // Close mobile menu on link click
  document.querySelectorAll('.mobile-menu__link, .mobile-menu__action').forEach(link => {
    link.addEventListener('click', () => {
      document.getElementById('mobile-menu')?.removeAttribute('open');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  // Thumbnail click → switch media (images + video)
  document.querySelectorAll('[data-thumbnail]').forEach(btn => {
    btn.addEventListener('click', () => {
      const mediaId = btn.dataset.mediaId;
      document.querySelectorAll('.pdp__media-item video').forEach(v => v.pause());
      document.querySelectorAll('.pdp__media-item').forEach(item => {
        item.classList.toggle('is-active', item.dataset.mediaId === mediaId);
      });
      document.querySelectorAll('[data-thumbnail]').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  // Quantity buttons
  const qtyInput = document.getElementById('pdp-qty');
  document.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
    if (!qtyInput) return;
    const val = parseInt(qtyInput.value);
    if (val > 1) qtyInput.value = val - 1;
  });
  document.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
    if (!qtyInput) return;
    qtyInput.value = parseInt(qtyInput.value) + 1;
  });

  // Variant picker — keep hidden id select + price + selected label + gallery in sync
  (function () {
    const variantSelect = document.getElementById('pdp-variant-select');
    const priceEl = document.getElementById('pdp-price');
    const gallery = document.querySelector('.pdp__gallery');
    const filterByVariant = gallery ? gallery.dataset.filterByVariant === 'true' : false;

    if (!variantSelect) return;

    const optionInputs = document.querySelectorAll('.pdp__variant-picker input[type="radio"]');
    if (optionInputs.length === 0) return;

    function getSelectedOptions() {
      const groups = {};
      optionInputs.forEach(inp => {
        if (inp.checked) groups[inp.name] = inp.value;
      });
      return groups;
    }

    function findVariant(selectedOptions) {
      const desired = Object.values(selectedOptions).join(' / ');
      for (const opt of variantSelect.options) {
        if (opt.text === desired) return opt;
      }
      return null;
    }

    function filterGalleryForVariant(variantId) {
      if (!filterByVariant || !gallery) return;
      const idStr = String(variantId);

      const apply = (el) => {
        const linked = (el.dataset.variantIds || '').split(',').filter(Boolean);
        // Always show if not linked to any variant (general media), or if linked to current
        const matches = linked.length === 0 || linked.includes(idStr);
        el.dataset.variantHidden = matches ? 'false' : 'true';
      };

      gallery.querySelectorAll('.pdp__media-item').forEach(apply);
      gallery.querySelectorAll('.pdp__thumbnail').forEach(apply);

      // Activate first visible media + thumbnail
      const firstVisibleItem = gallery.querySelector('.pdp__media-item[data-variant-hidden="false"]');
      gallery.querySelectorAll('.pdp__media-item').forEach(item => item.classList.remove('is-active'));
      if (firstVisibleItem) firstVisibleItem.classList.add('is-active');

      const firstVisibleThumb = gallery.querySelector('.pdp__thumbnail[data-variant-hidden="false"]');
      gallery.querySelectorAll('.pdp__thumbnail').forEach(t => t.classList.remove('is-active'));
      if (firstVisibleThumb) firstVisibleThumb.classList.add('is-active');
    }

    function updateUI() {
      const selectedOptions = getSelectedOptions();
      const variantOption = findVariant(selectedOptions);
      if (!variantOption) return;

      variantSelect.value = variantOption.value;
      variantSelect.dispatchEvent(new Event('change', { bubbles: true }));

      if (priceEl && variantOption.dataset.price) {
        priceEl.textContent = variantOption.dataset.price;
      }

      Object.entries(selectedOptions).forEach(([name, value]) => {
        document.querySelectorAll(`.pdp__variant-picker .pdp__option`).forEach(optBlock => {
          const label = optBlock.querySelector('.pdp__option-label');
          const inp = optBlock.querySelector(`input[name="${name}"]`);
          if (inp) {
            const selSpan = label && label.querySelector('.pdp__option-selected');
            if (selSpan) selSpan.textContent = value;
          }
        });
      });

      filterGalleryForVariant(variantOption.value);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantOption.value);
      window.history.replaceState({}, '', url.toString());
    }

    optionInputs.forEach(inp => inp.addEventListener('change', updateUI));

    // Apply filter on initial load
    const initial = findVariant(getSelectedOptions());
    if (initial) filterGalleryForVariant(initial.value);
  })();

  // Sticky Mobile ATC — show when main buy buttons scroll out of view
  (function () {
    const stickyBar = document.querySelector('[data-pdp-sticky-atc]');
    if (!stickyBar) return;

    const buyButtons = document.querySelector('.pdp__buy-buttons');
    if (!buyButtons) return;

    const breakpoint = parseInt(stickyBar.dataset.breakpoint, 10) || 768;
    const triggerBtn = stickyBar.querySelector('[data-sticky-trigger]');
    const stickyImg = stickyBar.querySelector('[data-sticky-image]');
    const stickyPrice = stickyBar.querySelector('[data-sticky-price]');

    function isMobile() {
      return window.matchMedia(`(max-width: ${breakpoint}px)`).matches;
    }

    function showBar() {
      if (!isMobile()) return;
      stickyBar.removeAttribute('hidden');
      // small timeout so the transition fires
      requestAnimationFrame(() => stickyBar.classList.add('is-visible'));
    }

    function hideBar() {
      stickyBar.classList.remove('is-visible');
      // Wait for transition to finish before hiding entirely
      setTimeout(() => stickyBar.setAttribute('hidden', ''), 300);
    }

    // Show bar when the real ATC buttons leave the viewport
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting && isMobile()) {
          showBar();
        } else {
          hideBar();
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });

    observer.observe(buyButtons);

    // Trigger the real ATC submit on tap
    if (triggerBtn) {
      triggerBtn.addEventListener('click', () => {
        const realBtn = document.querySelector('.pdp__add-to-cart');
        if (realBtn) realBtn.click();
      });
    }

    // Sync sticky image + price with variant select changes
    const variantSelect = document.getElementById('pdp-variant-select');
    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const opt = variantSelect.options[variantSelect.selectedIndex];
        if (!opt) return;
        if (stickyPrice && opt.dataset.price) stickyPrice.textContent = opt.dataset.price;
      });
    }

    // If user resizes from mobile→desktop while bar is showing, hide it
    window.addEventListener('resize', () => {
      if (!isMobile() && stickyBar.classList.contains('is-visible')) hideBar();
    });
  })();

  // Shoppable Video — carousel + modal player
  (function () {
    document.querySelectorAll('[data-pdp-shop-video]').forEach((root) => {
      const track = root.querySelector('[data-track]');
      if (!track) return;

      const prevBtn = root.querySelector('[data-prev]');
      const nextBtn = root.querySelector('[data-next]');
      const modal = root.querySelector('[data-modal]');
      const modalVideo = root.querySelector('[data-modal-video]');
      const closeBtn = root.querySelector('[data-close]');
      const form = root.querySelector('[data-modal-form]');
      const variantInput = root.querySelector('[data-variant-input]');
      const cta = root.querySelector('[data-cta]');
      // Tile buttons carry the same data-product-* attribute names, so scope these
      // queries to inside the modal to avoid matching a tile in the carousel.
      const linkPrimary = modal && modal.querySelector('[data-product-link]');
      const linkSecondary = modal && modal.querySelector('[data-product-link-secondary]');
      const imgEl = modal && modal.querySelector('[data-product-image]');
      const titleEl = modal && modal.querySelector('[data-product-title]');
      const priceEl = modal && modal.querySelector('[data-product-price]');
      const compareEl = modal && modal.querySelector('[data-product-compare]');
      const ratingFallback = root.querySelector('[data-rating-fallback]');
      const judgeMe = root.querySelector('[data-judgeme]');
      const yotpo = root.querySelector('[data-yotpo]');
      const loox = root.querySelector('[data-loox]');

      // Pause/play preview videos when they enter viewport
      const previews = root.querySelectorAll('[data-preview]');
      if ('IntersectionObserver' in window && previews.length) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const v = entry.target;
            if (entry.isIntersecting) {
              v.play().catch(() => {});
            } else {
              v.pause();
            }
          });
        }, { threshold: 0.25 });
        previews.forEach(v => io.observe(v));
      }

      // ===== Arrows =====
      function tileWidth() {
        const item = track.querySelector('.pdp-shop-video__item');
        if (!item) return 0;
        const gap = parseFloat(getComputedStyle(track).gap) || 8;
        return item.offsetWidth + gap;
      }

      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        const max = track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= max;
      }

      if (prevBtn) prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -tileWidth(), behavior: 'smooth' });
      });
      if (nextBtn) nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: tileWidth(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();

      // ===== Modal =====
      function toEmbedUrl(url) {
        const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]+)/);
        if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1';
        const vimeo = url.match(/vimeo\.com\/(\d+)/);
        if (vimeo) return 'https://player.vimeo.com/video/' + vimeo[1] + '?autoplay=1';
        return url;
      }

      function injectVideo(tile) {
        modalVideo.innerHTML = '';
        const file = tile.dataset.videoSrc;
        const ext = tile.dataset.videoExternal;
        if (ext) {
          const iframe = document.createElement('iframe');
          iframe.src = toEmbedUrl(ext);
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.allowFullscreen = true;
          modalVideo.appendChild(iframe);
        } else if (file) {
          const v = document.createElement('video');
          v.src = file;
          v.controls = true;
          v.autoplay = true;
          v.playsInline = true;
          modalVideo.appendChild(v);
        }
      }

      const variantPickerEl = modal && modal.querySelector('[data-modal-variant-picker]');
      const galleryTrack = modal && modal.querySelector('[data-modal-gallery-track]');
      const galleryDots = modal && modal.querySelector('[data-modal-gallery-dots]');

      function renderGallery(tile) {
        if (!galleryTrack || !galleryDots) return;
        let images = [];
        try {
          images = JSON.parse(tile.dataset.productImages || '[]');
        } catch (e) {}
        // Always include featured image as fallback if list is empty
        if (images.length === 0 && tile.dataset.productImage) {
          images = [tile.dataset.productImage];
        }

        const url = tile.dataset.productUrl || '#';
        const title = tile.dataset.productTitle || '';

        // Build slides
        galleryTrack.innerHTML = '';
        images.forEach((src, idx) => {
          const slide = document.createElement('a');
          slide.className = 'pdp-shop-video__modal-gallery-slide';
          slide.href = url;
          slide.tabIndex = -1;
          slide.dataset.index = String(idx);
          if (idx === 0) slide.dataset.productLink = '';

          const img = document.createElement('img');
          img.className = 'pdp-shop-video__modal-img';
          img.src = src;
          img.alt = title;
          img.loading = idx === 0 ? 'eager' : 'lazy';
          if (idx === 0) img.dataset.productImage = '';

          slide.appendChild(img);
          galleryTrack.appendChild(slide);
        });

        // Build dots (only if more than 1 image)
        galleryDots.innerHTML = '';
        if (images.length > 1) {
          images.forEach((_, idx) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'pdp-shop-video__modal-gallery-dot' + (idx === 0 ? ' is-active' : '');
            dot.dataset.index = String(idx);
            dot.setAttribute('aria-label', `Show image ${idx + 1}`);
            dot.addEventListener('click', () => {
              const target = galleryTrack.querySelector(`.pdp-shop-video__modal-gallery-slide[data-index="${idx}"]`);
              if (target) target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            });
            galleryDots.appendChild(dot);
          });
        }

        // Update active dot on scroll
        const onScroll = () => {
          const trackRect = galleryTrack.getBoundingClientRect();
          const slides = galleryTrack.querySelectorAll('.pdp-shop-video__modal-gallery-slide');
          let activeIdx = 0;
          slides.forEach((s) => {
            const rect = s.getBoundingClientRect();
            if (Math.abs(rect.left - trackRect.left) < rect.width / 2) {
              activeIdx = parseInt(s.dataset.index, 10);
            }
          });
          galleryDots.querySelectorAll('.pdp-shop-video__modal-gallery-dot').forEach((d) => {
            d.classList.toggle('is-active', parseInt(d.dataset.index, 10) === activeIdx);
          });
        };
        galleryTrack.removeEventListener('scroll', galleryTrack._scrollHandler);
        galleryTrack._scrollHandler = onScroll;
        galleryTrack.addEventListener('scroll', onScroll, { passive: true });

        // Reset scroll to first slide
        galleryTrack.scrollTo({ left: 0, behavior: 'auto' });
      }

      function setCta({ label, price, disabled }) {
        if (!cta) return;
        cta.disabled = !!disabled;
        const ctaLabel = cta.querySelector('[data-cta-label]');
        const ctaPrice = cta.querySelector('[data-cta-price]');
        const sep = cta.querySelector('.pdp-shop-video__modal-cta-sep');
        if (ctaLabel) ctaLabel.textContent = label;
        if (ctaPrice) ctaPrice.textContent = price || '';
        if (sep) sep.style.display = price ? '' : 'none';
      }

      function renderVariantPicker(tile) {
        if (!variantPickerEl) return;
        variantPickerEl.innerHTML = '';
        if (tile.dataset.productHasVariants !== 'true') return;

        let options, variants, patterns;
        try {
          options = JSON.parse(tile.dataset.productOptions || '[]');
          variants = JSON.parse(tile.dataset.productVariants || '[]');
          patterns = JSON.parse(tile.dataset.productVariantPatterns || '[]');
        } catch (e) {
          console.warn('[shoppable-video] failed to parse variants', e);
          return;
        }

        const patternByVariantId = {};
        patterns.forEach(p => { if (p && p.id) patternByVariantId[p.id] = p.pattern; });

        // Detect color-like options to render as swatches; others as buttons
        const colorRegex = /(color|farbe|colour|pattern|muster)/i;

        options.forEach((option) => {
          const optionWrap = document.createElement('div');
          optionWrap.className = 'pdp-shop-video__modal-option';

          const label = document.createElement('label');
          label.className = 'pdp-shop-video__modal-option-label';
          label.innerHTML = `Select ${option.name}: <span class="pdp-shop-video__modal-option-label-value" data-selected-value-for="${option.position}"></span>`;
          optionWrap.appendChild(label);

          const valuesWrap = document.createElement('div');
          valuesWrap.className = 'pdp-shop-video__modal-option-values';

          const isSwatch = colorRegex.test(option.name);

          option.values.forEach((value, idx) => {
            // Find a representative variant for this option value
            const optKey = `option${option.position}`;
            const matchingVariant = variants.find(v => v[optKey] === value);
            const isAvailable = variants.some(v => v[optKey] === value && v.available);
            // Prefer dedicated pattern metafield, fall back to variant featured image
            const patternUrl = matchingVariant && patternByVariantId[matchingVariant.id];
            const swatchImage = patternUrl ||
              (matchingVariant && matchingVariant.featured_image && matchingVariant.featured_image.src
                ? matchingVariant.featured_image.src
                : null);

            const id = `modal-opt-${option.position}-${idx}`;

            if (isSwatch) {
              const wrap = document.createElement('label');
              wrap.className = `pdp-shop-video__modal-swatch${isAvailable ? '' : ' pdp-shop-video__modal-swatch--unavailable'}`;
              wrap.title = value;
              wrap.setAttribute('aria-label', `${option.name}: ${value}`);

              const radio = document.createElement('input');
              radio.type = 'radio';
              radio.name = option.name;
              radio.value = value;
              radio.id = id;
              radio.dataset.optionPosition = option.position;
              if (idx === 0) radio.checked = true;

              const circle = document.createElement('span');
              circle.className = 'pdp-shop-video__modal-swatch-circle';
              if (swatchImage) {
                const img = document.createElement('img');
                img.src = swatchImage;
                img.alt = '';
                img.loading = 'lazy';
                circle.appendChild(img);
              }

              wrap.appendChild(radio);
              wrap.appendChild(circle);
              valuesWrap.appendChild(wrap);
            } else {
              const wrap = document.createElement('label');
              wrap.className = `pdp-shop-video__modal-button${isAvailable ? '' : ' pdp-shop-video__modal-button--unavailable'}`;

              const radio = document.createElement('input');
              radio.type = 'radio';
              radio.name = option.name;
              radio.value = value;
              radio.id = id;
              radio.dataset.optionPosition = option.position;
              if (idx === 0) radio.checked = true;

              const span = document.createElement('span');
              span.className = 'pdp-shop-video__modal-button-label';
              span.textContent = value;

              wrap.appendChild(radio);
              wrap.appendChild(span);
              valuesWrap.appendChild(wrap);
            }
          });

          optionWrap.appendChild(valuesWrap);
          variantPickerEl.appendChild(optionWrap);
        });

        // Set initial selected-value labels
        updateSelectedLabels();

        // Bind change handlers on option radios
        variantPickerEl.querySelectorAll('input[type="radio"]').forEach((r) => {
          r.addEventListener('change', () => {
            updateSelectedLabels();
            const selected = getSelectedOptions();
            const match = variants.find(v =>
              v.option1 === selected[0] &&
              (selected[1] === undefined || v.option2 === selected[1]) &&
              (selected[2] === undefined || v.option3 === selected[2])
            );
            if (match) {
              if (variantInput) variantInput.value = match.id;
              const formattedPrice = formatMoney(match.price);
              if (priceEl) priceEl.textContent = formattedPrice;
              if (compareEl) compareEl.textContent = match.compare_at_price && match.compare_at_price > match.price ? formatMoney(match.compare_at_price) : '';
              setCta({
                label: match.available ? 'In den Warenkorb' : 'Ausverkauft',
                price: match.available ? formattedPrice : '',
                disabled: !match.available,
              });
              // Scroll gallery to the variant's image if found
              if (galleryTrack && match.featured_image && match.featured_image.src) {
                const slides = galleryTrack.querySelectorAll('.pdp-shop-video__modal-gallery-slide img');
                slides.forEach((img, idx) => {
                  if (img.src === match.featured_image.src || img.src.includes(match.featured_image.src.split('?')[0].split('/').pop())) {
                    const slide = img.closest('.pdp-shop-video__modal-gallery-slide');
                    if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                  }
                });
              }
            }
          });
        });

        function getSelectedOptions() {
          const opts = [];
          variantPickerEl.querySelectorAll('input[type="radio"]:checked').forEach((r) => {
            opts[parseInt(r.dataset.optionPosition, 10) - 1] = r.value;
          });
          return opts;
        }

        function updateSelectedLabels() {
          variantPickerEl.querySelectorAll('input[type="radio"]:checked').forEach((r) => {
            const lbl = variantPickerEl.querySelector(`[data-selected-value-for="${r.dataset.optionPosition}"]`);
            if (lbl) lbl.textContent = r.value;
          });
        }
      }

      function formatMoney(cents) {
        // Prices in Shopify variant.price are cents (integer in Liquid JSON output)
        // Format to a basic € currency string. Fallback to raw value if not integer.
        if (typeof cents !== 'number') return cents;
        const value = (cents / 100).toFixed(2).replace('.', ',');
        return `€${value}`;
      }

      function fillSide(tile) {
        const handle = tile.dataset.productHandle;
        const url = tile.dataset.productUrl || '#';
        const title = tile.dataset.productTitle || '';
        const price = tile.dataset.productPrice || '';
        const compare = tile.dataset.productCompare || '';
        const variantId = tile.dataset.variantId || '';
        const productId = tile.dataset.productId || '';
        const soldOut = tile.dataset.soldOut === 'true';

        // Build gallery first so [data-product-image] exists for variant-picker swaps
        renderGallery(tile);

        if (linkSecondary) linkSecondary.href = url;
        if (titleEl) titleEl.textContent = title;
        if (priceEl) priceEl.textContent = price;
        if (compareEl) compareEl.textContent = compare;
        if (variantInput) variantInput.value = variantId;
        setCta({
          label: soldOut ? 'Ausverkauft' : 'In den Warenkorb',
          price: soldOut ? '' : price,
          disabled: soldOut || !variantId,
        });

        // Render variant picker for the linked product
        renderVariantPicker(tile);

        // Update review widgets data-id so they re-render for the linked product
        if (judgeMe) judgeMe.setAttribute('data-id', productId);
        if (yotpo) yotpo.setAttribute('data-product-id', productId);
        if (loox) loox.setAttribute('data-id', productId);

        // Refresh widgets if installed
        if (window.jdgm && window.jdgm.customizeBadges) try { window.jdgm.customizeBadges(); } catch (e) {}
        if (window.yotpo && window.yotpo.refreshWidgets) try { window.yotpo.refreshWidgets(); } catch (e) {}
      }

      root.querySelectorAll('[data-tile]').forEach((tile) => {
        if (tile.classList.contains('pdp-shop-video__tile--placeholder')) return;
        tile.addEventListener('click', () => {
          injectVideo(tile);
          fillSide(tile);
          if (typeof modal.showModal === 'function') {
            modal.showModal();
          } else {
            modal.setAttribute('open', '');
          }
        });
      });

      function closeModal() {
        modalVideo.innerHTML = '';
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
      }

      if (closeBtn) closeBtn.addEventListener('click', closeModal);
      modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });
      modal.addEventListener('cancel', () => { modalVideo.innerHTML = ''; });

      // ATC submit via fetch
      if (form) {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          if (!variantInput.value) return;

          const ctaLabel = cta.querySelector('[data-cta-label]');
          const ctaPrice = cta.querySelector('[data-cta-price]');
          const sep = cta.querySelector('.pdp-shop-video__modal-cta-sep');
          const originalLabel = ctaLabel ? ctaLabel.textContent : cta.textContent;
          const originalPrice = ctaPrice ? ctaPrice.textContent : '';
          const setLabel = (txt, hidePrice) => {
            if (ctaLabel) ctaLabel.textContent = txt;
            else cta.textContent = txt;
            if (hidePrice) {
              if (ctaPrice) ctaPrice.textContent = '';
              if (sep) sep.style.display = 'none';
            }
          };

          cta.disabled = true;
          setLabel('...', true);

          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Accept': 'application/json' },
              body: new FormData(form),
            });
            if (!res.ok) throw new Error('cart/add failed');
            setLabel('Added ✓', true);
            document.dispatchEvent(new CustomEvent('cart:updated'));
            setTimeout(() => {
              closeModal();
              setLabel(originalLabel, false);
              if (ctaPrice) ctaPrice.textContent = originalPrice;
              if (sep && originalPrice) sep.style.display = '';
              cta.disabled = false;
            }, 800);
          } catch (err) {
            console.error('Shoppable video ATC', err);
            setLabel('Fehler', true);
            setTimeout(() => {
              setLabel(originalLabel, false);
              if (ctaPrice) ctaPrice.textContent = originalPrice;
              if (sep && originalPrice) sep.style.display = '';
              cta.disabled = false;
            }, 1500);
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-shoppable-video]');
    if (!sections.length) return;

    sections.forEach((section) => {
      const carousel = section.querySelector('[data-carousel]');
      const prevBtn = section.querySelector('[data-carousel-prev]');
      const nextBtn = section.querySelector('[data-carousel-next]');
      const modal = section.querySelector('[data-modal]');
      const modalVideo = section.querySelector('[data-modal-video]');
      const modalClose = section.querySelector('[data-modal-close]');
      const modalForm = section.querySelector('[data-modal-form]');
      const modalVariantId = section.querySelector('[data-modal-variant-id]');
      const modalCta = section.querySelector('[data-modal-cta]');
      const modalLink = section.querySelector('[data-modal-product-link]');
      const modalLinkSecondary = section.querySelector('[data-modal-product-link-secondary]');
      const modalImage = section.querySelector('[data-modal-product-image]');
      const modalTitle = section.querySelector('[data-modal-product-title]');
      const modalPrice = section.querySelector('[data-modal-product-price]');
      const modalCompare = section.querySelector('[data-modal-product-compare]');

      // ===== Carousel arrows =====
      function getTileWidth() {
        const tile = carousel.querySelector('.shoppable-video__tile-wrap');
        if (!tile) return 0;
        const style = window.getComputedStyle(carousel);
        const gap = parseInt(style.gap, 10) || 16;
        return tile.offsetWidth + gap;
      }

      function updateArrows() {
        if (!prevBtn || !nextBtn) return;
        const max = carousel.scrollWidth - carousel.clientWidth - 1;
        prevBtn.disabled = carousel.scrollLeft <= 0;
        nextBtn.disabled = carousel.scrollLeft >= max;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          carousel.scrollBy({ left: -getTileWidth(), behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          carousel.scrollBy({ left: getTileWidth(), behavior: 'smooth' });
        });
      }
      carousel.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();

      // ===== Modal open/close =====
      function injectVideo(tile) {
        const fileSrc = tile.dataset.videoSrc;
        const externalUrl = tile.dataset.videoExternal;
        modalVideo.innerHTML = '';

        if (externalUrl) {
          const iframe = document.createElement('iframe');
          iframe.src = toEmbedUrl(externalUrl);
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.allowFullscreen = true;
          modalVideo.appendChild(iframe);
        } else if (fileSrc) {
          const video = document.createElement('video');
          video.src = fileSrc;
          video.controls = true;
          video.autoplay = true;
          video.playsInline = true;
          modalVideo.appendChild(video);
        }
      }

      function toEmbedUrl(url) {
        const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]+)/);
        if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1';
        const vimeo = url.match(/vimeo\.com\/(\d+)/);
        if (vimeo) return 'https://player.vimeo.com/video/' + vimeo[1] + '?autoplay=1';
        return url;
      }

      function fillSidebar(tile) {
        const handle = tile.dataset.productHandle;
        const productUrl = tile.dataset.productUrl || '#';
        const title = tile.dataset.productTitle || '';
        const image = tile.dataset.productImage || '';
        const price = tile.dataset.productPrice || '';
        const compare = tile.dataset.productCompare || '';
        const variantId = tile.dataset.variantId || '';
        const ctaLabel = tile.dataset.ctaLabel || 'In den Warenkorb';
        const soldOut = tile.dataset.soldOut === 'true';

        if (modalLink) modalLink.href = productUrl;
        if (modalLinkSecondary) modalLinkSecondary.href = productUrl;
        if (modalImage) {
          modalImage.src = image;
          modalImage.alt = title;
        }
        if (modalTitle) modalTitle.textContent = title;
        if (modalPrice) modalPrice.textContent = price;
        if (modalCompare) modalCompare.textContent = compare;
        if (modalVariantId) modalVariantId.value = variantId;

        if (modalCta) {
          modalCta.textContent = soldOut ? 'Ausverkauft' : ctaLabel;
          modalCta.disabled = soldOut || !variantId;
        }

        // Hide form/CTA if there's no linked product at all
        if (modalForm) {
          modalForm.style.display = handle ? '' : 'none';
        }
      }

      section.querySelectorAll('[data-video-tile]').forEach((tile) => {
        if (tile.classList.contains('shoppable-video__tile--placeholder')) return;
        tile.addEventListener('click', () => {
          injectVideo(tile);
          fillSidebar(tile);
          if (typeof modal.showModal === 'function') {
            modal.showModal();
          } else {
            modal.setAttribute('open', '');
          }
        });
      });

      function closeModal() {
        // Stop video playback by clearing the player node
        modalVideo.innerHTML = '';
        if (typeof modal.close === 'function') {
          modal.close();
        } else {
          modal.removeAttribute('open');
        }
      }

      if (modalClose) modalClose.addEventListener('click', closeModal);

      // Close on backdrop click
      modal.addEventListener('click', (e) => {
        if (e.target === modal) closeModal();
      });

      // Close on Esc — native dialog dispatches `cancel`
      modal.addEventListener('cancel', () => {
        modalVideo.innerHTML = '';
      });

      // ===== ATC submit via fetch — keep user in modal, open cart drawer =====
      if (modalForm) {
        modalForm.addEventListener('submit', async (e) => {
          e.preventDefault();
          const variantId = modalVariantId.value;
          if (!variantId) return;

          modalCta.disabled = true;
          const originalLabel = modalCta.textContent;
          modalCta.textContent = '...';

          try {
            const formData = new FormData(modalForm);
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Accept': 'application/json' },
              body: formData,
            });
            if (!res.ok) throw new Error('cart/add failed');

            modalCta.textContent = 'Added ✓';
            // Notify cart drawer / counter listeners if any
            document.dispatchEvent(new CustomEvent('cart:updated'));

            setTimeout(() => {
              closeModal();
              modalCta.textContent = originalLabel;
              modalCta.disabled = false;
            }, 800);
          } catch (err) {
            console.error('Shoppable video ATC error', err);
            modalCta.textContent = 'Fehler';
            setTimeout(() => {
              modalCta.textContent = originalLabel;
              modalCta.disabled = false;
            }, 1500);
          }
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-video-grid]').forEach((root) => {
      const track = root.querySelector('[data-track]');
      if (!track) return;

      // In the Shopify theme editor, selecting a block/video programmatically
      // focuses it, which triggers the global burgundy :focus-visible ring and
      // looks like a random pink highlight. Flag the editor so we can drop that
      // ring here only — real keyboard focus on the live storefront keeps it.
      if (window.Shopify && window.Shopify.designMode) {
        root.setAttribute('data-design-mode', '');
      }

      const prevBtn = root.querySelector('[data-prev]');
      const nextBtn = root.querySelector('[data-next]');
      const modal = root.querySelector('[data-modal]');
      const modalVideo = root.querySelector('[data-modal-video]');
      const modalCaption = root.querySelector('[data-modal-caption]');
      const modalClose = root.querySelector('[data-modal-close]');

      // ===== Autoplay previews when in view =====
      const previews = root.querySelectorAll('[data-preview]');
      if ('IntersectionObserver' in window && previews.length) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const v = entry.target;
            if (entry.isIntersecting) v.play().catch(() => {});
            else v.pause();
          });
        }, { threshold: 0.25 });
        previews.forEach((v) => io.observe(v));
      }

      // ===== Carousel arrows =====
      function tileWidth() {
        const item = track.querySelector('.video-grid__item');
        if (!item) return 0;
        const gap = parseFloat(getComputedStyle(track).gap) || 10;
        return item.offsetWidth + gap;
      }

      function updateArrows() {
        // Toggle the peek/scroll affordance when the tiles overflow the row.
        // Hysteresis: turning the peek on narrows the tiles (smaller scrollWidth),
        // so we only turn it back off once the row clearly fits even without the
        // peek (deadband > max peek width) — otherwise it would flicker on/off.
        const overflow = track.scrollWidth - track.clientWidth;
        if (!root.classList.contains('is-scrollable')) {
          if (overflow > 2) root.classList.add('is-scrollable');
        } else if (overflow < -80) {
          root.classList.remove('is-scrollable');
        }
        if (!prevBtn || !nextBtn) return;
        const max = track.scrollWidth - track.clientWidth - 1;
        prevBtn.disabled = track.scrollLeft <= 0;
        nextBtn.disabled = track.scrollLeft >= max;
      }

      if (prevBtn) prevBtn.addEventListener('click', () => track.scrollBy({ left: -tileWidth(), behavior: 'smooth' }));
      if (nextBtn) nextBtn.addEventListener('click', () => track.scrollBy({ left: tileWidth(), behavior: 'smooth' }));
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();

      if (!modal) return;

      // ===== Modal: video injection =====
      function toEmbedUrl(url) {
        const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]+)/);
        if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1';
        const vimeo = url.match(/vimeo\.com\/(\d+)/);
        if (vimeo) return 'https://player.vimeo.com/video/' + vimeo[1] + '?autoplay=1';
        return url;
      }

      let lastTrigger = null;
      let triggerWasKeyboard = false;

      function openModal(tile, evt) {
        lastTrigger = tile;
        // Keyboard activation (Enter/Space on the button) reports detail === 0;
        // real pointer clicks report >= 1. We use this to decide whether the
        // focus ring should come back when the modal closes.
        triggerWasKeyboard = !evt || evt.detail === 0;
        const src = tile.dataset.videoSrc;
        const ext = tile.dataset.videoExternal;
        const caption = tile.dataset.caption || '';
        modalVideo.innerHTML = '';
        if (ext) {
          const iframe = document.createElement('iframe');
          iframe.src = toEmbedUrl(ext);
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
          iframe.allowFullscreen = true;
          modalVideo.appendChild(iframe);
        } else if (src) {
          const v = document.createElement('video');
          v.src = src;
          v.controls = true;
          v.autoplay = true;
          v.playsInline = true;
          modalVideo.appendChild(v);
        }
        if (modalCaption) modalCaption.textContent = caption;
        if (typeof modal.showModal === 'function') modal.showModal();
        else modal.setAttribute('open', '');
      }

      function closeModal() {
        modalVideo.innerHTML = '';
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
      }

      root.querySelectorAll('[data-video-tile]').forEach((tile) => {
        tile.addEventListener('click', (e) => openModal(tile, e));
      });

      if (modalClose) modalClose.addEventListener('click', closeModal);
      modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });

      // Fires for every close path (Escape, .close(), backdrop). A <dialog>
      // restores focus to the tile that opened it; for pointer-driven opens
      // Chrome then flags the tile :focus-visible, leaving a stray highlight
      // ring on the video. Drop it for mouse/touch users; keep it for keyboard
      // users, who rely on the ring to know where focus landed.
      modal.addEventListener('close', () => {
        modalVideo.innerHTML = '';
        if (!triggerWasKeyboard && lastTrigger) lastTrigger.blur();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
